import type { DrinkCategory } from '@/types/data';

/** Unique landing copy for category catalog routes (AdSense / curation layer). */
export const CATEGORY_INTROS: Record<DrinkCategory, { title: string; body: string }> = {
  beer: {
    title: 'Beer comparisons',
    body:
      'Browse lagers, IPAs, stouts, and more by alcohol per 100 calories and alcohol per dollar. US beer packs are often labeled in fluid ounces; ABV and calories still scale with serving size. Use subtype filters to narrow styles, set a baseline light lager or IPA you know, and override package prices to match your store. Rankings describe composition and grocery-style value — not taste awards or intoxication. For adults of legal drinking age.',
  },
  liquor: {
    title: 'Liquor & spirits',
    body:
      'Spirits rows often use regional reference prices such as Virginia ABC list prices where imported. Those figures are control-state references, not a national average — edit prices on Compare for your shelf. Alcohol per 100 calories is frequently high for neat pours because most energy is ethanol; mixers change the story for cocktails. BoozeRatio does not sell alcohol. Drink responsibly.',
  },
  wine: {
    title: 'Wine',
    body:
      'Wine servings are commonly normalized around a 5 fl oz pour in education materials, but bottle and ABV vary widely. Sort by alcohol per 100 calories to see how residual sweetness and strength move calorie efficiency, and use package offers for bottle value. Regional ABC references, when present, are labeled by region. Verify labels for vintage-sensitive products.',
  },
  'mixed-drinks': {
    title: 'Mixed drinks (recipe estimates)',
    body:
      'Mixed-drink rows are home-preparation models with explicit ingredients — useful for comparing mixer choices like soda versus tonic, not for predicting bar menu prices. Nutrition and cost are estimates. Open a recipe detail for assumptions, then Compare two builds with the same spirit pour. These are informational models for adults of legal drinking age.',
  },
  seltzers: {
    title: 'Hard seltzers & canned cocktails',
    body:
      'Hard seltzers often advertise low carbs and ~100 calories near 4–5% ABV. Remember that alcohol itself carries calories — zero carbs is not zero energy. Rank by alcohol per 100 calories within the category, and compare multipack alcohol per dollar with your local price. Flavored malt beverages and canned cocktails may differ sharply from true seltzers; read subtypes carefully.',
  },
  cider: {
    title: 'Cider',
    body:
      'Ciders vary from dry to sweet; sugar and ABV both move calories. Use alcohol per 100 calories to compare composition and package alcohol per dollar for value. Serving sizes may be listed in fl oz like beer. Missing nutrition stays unknown rather than zero. Explore guides for standard-drink math if you are matching ethanol across styles.',
  },
};
